/**
 * Every root-marketing landing path, as one flat list.
 *
 * Separate from the pages themselves, which are in the CMS, because
 * `src/content/prerenderPages.ts` reads this and `vite.config.mts` imports THAT
 * by relative path, letting esbuild inline it into the bundled config. A config
 * pass has no adapter to await and no `fs` to read an index with, so the paths
 * have to be here as literals. `src/routes/$landing.tsx` reads it for the same
 * reason from the other side: parsing runs on every root URL, and reaching the
 * CMS from there would put a read on every navigation.
 *
 * The list is written by `scripts/refresh-sanity-index.mjs`, which is what
 * stops it drifting from the CMS. Only the membership: the order is nobody's
 * to decide, so the script keeps what is already listed and appends what the
 * Studio has added since. Add a page in the Studio, run the script, and the
 * page is served and prerendered.
 */
export const LANDING_PATHS: ReadonlyArray<string> = [
  "/affiliate-program",
  "/brightdata-alternative",
  "/chrome-proxy-extension",
  "/dataimpulse-alternative",
  "/decodo-alternative",
  "/dedicated-datacenter-proxy",
  "/dedicated-proxy",
  "/dedicated-static-residential-proxy",
  "/frequently-asked-questions",
  "/integrations",
  "/iproyal-alternative",
  "/private-datacenter-proxy",
  "/private-proxy",
  "/private-static-residential-proxy",
  "/product-comparison",
  "/proxy-seller-alternative",
  "/proxy-server",
  "/pyproxy-alternative",
  "/rayobyte-alternative",
  "/referral-program",
  "/residential-proxy",
  "/rotating-proxy",
  "/static-residential-proxy",
  "/thordata-alternative",
  "/use-cases",
  "/youtube-proxy",
  "/use-cases/amazon-proxy-server",
  "/use-cases/ecommerce-proxies",
  "/use-cases/gaming-proxy-server",
  "/use-cases/proxies-for-ad-verification-monitoring",
  "/use-cases/proxies-for-brand-monitoring",
  "/use-cases/proxies-for-cyber-security",
  "/use-cases/proxies-for-market-research",
  "/use-cases/proxies-for-price-tracking-monitoring",
  "/use-cases/seo-proxies",
  "/use-cases/social-media-proxies",
  "/use-cases/web-scraping-data-extraction",
  "/webshares-ethically-sourced-residential-proxies",
  "/l/cvamp",
  "/l/blackdown",
  "/l/cybernews",
  "/l/designrush",
  "/l/dginnovations",
  "/l/jdepoix",
  "/l/privateproxyreviews",
  "/l/promo",
  "/l/promo15",
  "/l/proxies",
  "/l/proxyway",
  "/l/vpncentral",
  "/l/dedicated-isp-proxies",
  "/l/dedicated-proxy",
  "/l/residential-proxy",
  "/l/rotating-residential-proxy",
  "/l/static-residential-proxies",
  "/l/best-proxies",
  "/l/best-proxy",
  "/l/premium-proxy",
  "/l/proxy-start",
  "/enterprise-form",
];

/** The shape `prerenderPages.ts` splices into its page list. */
export function landingPagePaths(): Array<string> {
  return [...LANDING_PATHS];
}
